<template lang="pug">
  el-main
    el-card(class="box-card")
      div(
        slot="header"
        class="clearfix"
        )
        img(
          class="library-icon"
          :src="libraryIcon"
        )
        span(class="form-title") {{ headerLabel }} 
        el-button.margin-left-15(
          class="normal-button"
          @click="$emit('showLibraryModal')"
          :loading="processing"
          icon="el-icon-notebook-2")
            small Switch
        div(style="float: right")
          el-button(
            class="normal-button"
            @click="$emit('formCancelClicked')"
            icon="el-icon-error") 
              small Cancel    
          el-button(
            class="primary-button"
            @click="importQuestions"
            icon="el-icon-download"
            :loading="processing"
            :disabled="!selectionMade") 
              small Copy   

      el-row(style="margin: 0% 2% 0% 2%; display: flex; flex-direction: row; justify-content: left; flex-wrap: wrap; align-items: baseline;")
        el-select#tag-select(
            v-model="value"
            multiple
            filterable
            reserve-keyword
            clearable
            placeholder="Please enter a tag to search"
            no-data-text="No tags found"
            no-match-text="No tag matches found"
            :loading="loading")
            el-option#tag-options(
              v-for="item in tagsList"
                :key="item.id"
                :label="item.text"
                :value="item.text"
            )
        el-button(
            class="primary-button"
            @click="search(true)"
            icon="el-icon-search") 
              small Search

      // Pagination
      el-row
        div(style="float:right; margin: 2%")
          el-pagination(
            v-if="pagination.totalQuestions > maxPageLimit"
            :page-size="maxPageLimit"
            :total="pagination.totalQuestions"
            :current-page="pagination.currentPage"
            @next-click="pageChange(1)"
            @prev-click="pageChange(-1)"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            style="float:right;")
  
      el-row
        div(v-for="item in questionList")
          question-placeholder(
            :id="item.id"
            :questionData="item"
            :showPreview="true"
            :showTags="true"
            :tagsList="tagsList"
            :selectOnly="true"
            @questionSelected="onQuestionSelected")

      // Pagination
      el-row
        div(style="float:right; margin: 2%")
          el-pagination(
            v-if="pagination.totalQuestions > maxPageLimit"
            :page-size="maxPageLimit"
            :total="pagination.totalQuestions"
            :current-page="pagination.currentPage"
            @next-click="pageChange(1)"
            @prev-click="pageChange(-1)"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            style="float:right;")
</template>
 

<script>
  import QuestionPlaceholder from '@/components/instructor/Question/Placeholder/QuestionPlaceholder'
  import utilMixin from '@/components/mixins/utilMixin'
  import {SUPER_QUIZ_ID, MAX_PAGE_LIMIT, LIBRARY_TYPES} from '@/defines/constants'

  export default {
    name: 'QuestionLibrary',
    components: {
      QuestionPlaceholder,
    },

    mixins: [utilMixin],

    props: {
      libraryType: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        value: [],
        loading: false,
        processing: false,
        tagsList: [],
        questionList: [],
        selectedQuestionsList: [],
        pagination: {
          totalQuestions: 0,
          currentPage: 1,
        },
        maxPageLimit: MAX_PAGE_LIMIT,
        pointsMsg: '<br><br><div class="points-import-note"><span style="color:red;">*</span><span style="font-size: 14px"> Assign default point(s) per question:</span></div>',
      }
    },

    computed: {
      selectionMade() {
        return (this.selectedQuestionsList.length > 0)
      },

      headerLabel() {
        return `Import Questions from ${this.libraryType.charAt(0).toUpperCase() + this.libraryType.slice(1)} Library`
      },

      /* eslint-disable */
      libraryIcon: {
        get() {
          return require(`@/assets/LibraryTypes/${this.libraryType}_library.svg`)
        }
      },
      /* eslint-enable */
    },

    watch: {
      libraryType() {
        this.fetchTags()
      },
    },
    
    mounted() {
      this.fetchTags()
    },

    methods: {
      fetchTags() {
        this.tagsList = []
        this.questionList = []
        this.$emit('onProcessing', true)
        this.axios.get(`/api/tags/${LIBRARY_TYPES[this.libraryType]}`)
          .then((result) => {
            result.data.tags.forEach((item) => {
              this.tagsList.push(item)
            })
            this.$emit('onProcessing', false)
          })
          .catch((error) => {
            this.mNotification({error: error, message: 'Unable to retrieve list of tags.'})
          })            
      },

      search(searchClicked) {
        let tagIds = []
        this.value.forEach((item, index) => {
          for (let i=0; i<this.tagsList.length; i += 1) {
            if (this.tagsList[i].text === item) {
              tagIds.push(this.tagsList[i].id)
              break
            }
          }
        })

        let searchData = { library: LIBRARY_TYPES[this.libraryType] }
        if (searchClicked !== undefined) {
          searchData.tagIds = tagIds
        } else {
          searchData.page = this.pagination.currentPage - 1
        }

        this.$emit('onProcessing', true)
        this.axios.get('/api/quiz/' + SUPER_QUIZ_ID  + '/question', {
          params: searchData,
        })
          .then((result) => {
            if (result.data.total > 0 ) {
              this.questionList = []
              result.data.object.forEach((item, index) => {
                item.isSelected = (this.selectedQuestionsList.indexOf(item.id) >= 0)
                this.questionList.push(item)
              })
              this.pagination.totalQuestions = result.data.total
              if (searchClicked !== undefined) {
                this.pagination.currentPage = 1
              }
            } else {
              this.mNotification({info:"No questions found that match the given criteria."})
            }

            this.processing = false
            this.$emit('onProcessing', false)
          })
          .catch((error) => {
            this.$store.state.quizData = {}
            this.mNotification({error: error, message: 'Your Question list was not fully retrieved.'})
          })
      },

      getSelectedIDs() {
        let selectedIDs = []
        this.questionList.forEach((item) => {
          if ( item.isSelected ) {
            selectedIDs.push(item.id)
          }
        })
        return selectedIDs
      },

      goImport(value, selectedIDs) {
        if (value > 0) {
          this.processing = true
          this.axios.post('/api/quiz/' + SUPER_QUIZ_ID + '/question/import', {
            questionIds: selectedIDs,
            points: value,
          })
          .then((result) => {
            this.$emit('onQuestionImported')
            this.$emit('formCancelClicked')
            if (result.data.isImported) {
              this.mNotification({message: 'Your selected question(s) have been imported.'})
            } else {
              this.mNotification({error: true, title: 'Import Failed', message: 'Your selected question(s) were not imported.'})
            }
            this.processing = false
          })
          .catch((error) => {
            this.$emit('formCancelClicked')
            this.mNotification({error: error, message: 'There was an error saving your questions.'})
            this.processing = false
          })
        }
      },

      importQuestions() {
        let selectedIDs = this.selectedQuestionsList
        if ( selectedIDs.length < 1 ) {
          this.mNotification({info:"Please select questions to import."})
        } else if ( selectedIDs.length > MAX_PAGE_LIMIT ) {
          this.mNotification({warning: 'Only ' + MAX_PAGE_LIMIT + ' questions can be selected at a time.'})
        } else {
          let msg = '<span style="font-size: 16px">Do you want to copy <strong>' + selectedIDs.length + '</strong> question'+ (selectedIDs.length>1?'s':'')  + ' ?</span>'
          let importSettings = {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'Import',
            cancelButtonText: 'Cancel',
            confirmButtonClass: 'primary-button',
          }

          if (this.$store.state.quizData.isGraded) {
            msg += this.pointsMsg
            importSettings.inputPattern = /^[1-9]\d*$/
            importSettings.inputErrorMessage = 'Please input a valid point value'

            // Graded import
            this.$prompt(msg, 'Import Questions',
              importSettings)
              .then(({value}) => {
                this.goImport(value, selectedIDs)
              })
              .catch(() => { })
          } else {
            importSettings.title = 'Import Questions'
            importSettings.message = msg

            // Modules import
            this.$msgbox(importSettings)
              .then(() => {
                this.goImport(1, selectedIDs)
              })
              .catch(() => { })
          }
        }
      },
       
      pageChange(step) {
        let totalPages = this.pagination.totalQuestions / this.maxPageLimit
        if (step > 0) {
          if (this.pagination.currentPage < totalPages) {
            this.pagination.currentPage += 1
          }
        } else {
          if (this.pagination.currentPage > 1) {
            this.pagination.currentPage -= 1
          }
        }
        this.search()
      },

      handleCurrentChange(page) {
        this.pagination.currentPage = page
        this.search()
      },

      onQuestionSelected(id, status) {
        if (status) {
          if (this.selectedQuestionsList.indexOf(id) === -1) {
            this.selectedQuestionsList.push(id)
          }
        } else {
          if (this.selectedQuestionsList.indexOf(id) >= 0) {
            this.selectedQuestionsList.splice(this.selectedQuestionsList.indexOf(id), 1)
          }
        }
      },
    },
}
</script>

<style>
  #tag-select {
    width: 300px;
  }

  #tag-options {
    font-size: 16px;
  }

 #tag-text {
    font-size: 14px;
    color: #00a8ff;
    display:block;
    margin-top: 8px;
  }

  .library-icon {
    width: 2.5em;
    height: 2.5em;
    padding-right: 0.5em;
    vertical-align: top;
  }
</style>